<template>
  <table class="cart-table w-full text-NotoSansRegular" :class="{checkTable: stepNum === 'step3'}" v-if="products && products.length > 0">
    <thead>
      <tr class="w-full text-sm whitespace-no-wrap border-t border-b textColorBlack">
        <th class="w-6/13 px-4 py-2 font-normal">商品資訊</th>
        <th class="w-2/13 px-4 py-2 font-normal">數量</th>
        <th class="w-1/13 px-4 py-2 font-normal">原價</th>
        <th class="w-1/13 px-4 py-2 font-normal">折扣價</th>
        <th class="w-1/13 px-4 py-2 font-normal">小計</th>
        <th class="w-1/13 px-4 py-2 font-normal"  v-if="!stepNum">下次買</th>
        <th class="w-1/13 px-4 py-2 font-normal" v-if="!stepNum">刪除</th>
      </tr>
    </thead>
    <tbody>
      <tr class="text-xs border-b" v-for="(item, index) in products" :key="index">
        <td class="px-2 sm:px-4 py-4 md:py-6">
          <div class="flex items-start">
            <div class="w-24 md:w-32">
              <a class="itemImg cursor-pointer relative block" @click="routerChange(item)">
                <progressive-img v-if="item.cover"
                  :src="item.cover"
                  :placeholder="item.cover"
                  :blur="30"
                  :customClass="'max-w-full w-32'"
                  :aspect-ratio="1"
                />
                <progressive-img v-else
                  :src="default_url"
                  :placeholder="default_url"
                  :blur="30"
                  :customClass="'max-w-full'"
                  :aspect-ratio="1"
                />
                <div class="digi-mask mx-auto absolute top-0 left-0 z-40" v-if="item.is_digital">
                  <img src="~@/assets/icon/mask.png" class="w-full h-full object-contain mx-auto">
                </div>
              </a>
            </div>
            <div class="flex flex-col justify-center pl-2">
              <p class="textColorBlack">
                <span v-if="item.type === 'MAGAZINE'">雜誌</span>
                <span v-if="item.type === 'SUBSCRIPTION'">訂閱</span>
                <span v-if="item.type === 'BOOK'">叢書</span>
                <span v-if="item.type === 'PACKAGE'">套書</span>
                <span v-if="item.type === 'ITEM'">商品</span>
              </p>
              <a class="textColorBlack cursor-pointer text-NotoSansBold" @click="routerChange(item)">
                <p class="leading-loose" v-if="item.type !== 'SUBSCRIPTION'">{{ item.name }}</p>
                <p class="leading-loose" v-if="item.type === 'SUBSCRIPTION'">{{ item.link_name }}</p>
                <p class="leading-loose" v-if="item.type === 'SUBSCRIPTION'">
                  <span>期數：</span>
                  {{ item.name }}
                </p>
              </a>
              <p class="leading-loose textColorBlack text-NotoSansBold" v-if="item.type === 'SUBSCRIPTION'">
                <span>起訖：</span>{{ moment(item.begin_at).format('YYYY/MM') }}~{{ moment(item.end_at).format('YYYY/MM') }}
              </p>
              <p class="leading-loose textColorBlack text-NotoSansBold" v-if="item.type === 'SUBSCRIPTION' && !item.is_digital">寄送：
                <span v-if="item.isRegisteredMail">掛號</span>
                <span v-if="!item.isRegisteredMail">平信</span>
              </p>
              <!-- 贈品 -->
              <p class="text-NotoSansBold leading-loose text-pinky" v-if="(item.selected_gifts.length > 0) || (item.free_items.length > 0)">贈品：</p>
              <div v-if="item.selected_gifts && item.selected_gifts.length > 0" class="text-pinky">
                <p class="leading-loose" v-for="(child, idx) in item.selected_gifts" :key="idx">
                  <span>{{ child.name }}</span>
                  <span v-if="child.out_of_stock" class="bgLiveBlack text-white px-1 ml-1">贈品已贈完<checkOutStock :pName="child.name" /></span>
                </p>
              </div>
              <div v-if="item.free_items && item.free_items.length > 0" class="text-pinky">
                <p class="leading-loose" v-for="(child, idx) in item.free_items" :key="idx">
                  <span>{{ child.name }}</span>
                  <span v-if="child.out_of_stock" class="bgLiveBlack text-white px-1 ml-1">贈品已贈完<checkOutStock :pName="child.name" /></span>
                </p>
              </div>
              <!-- 活動贈品 -->
              <div class="hidden md:block">
                <router-link :to="{ name: 'sale', params: { category: 'book' }, query: { tag: item.event_id } }" class="hover:underline">
                  <p v-if="item.event && !item.matched && !stepNum">
                  <span class="textColorRed mr-1">(未符合)</span>
                  <span class="textColorRed" >{{ item.event }}</span>
                </p>
                  <p v-if="item.event && item.matched">
                    <span class="textColorRed mr-1">(已符合)</span>
                    <span class="textColorRed" >{{ item.event }}</span>
                  </p>
                  <p v-if="item.gifts">
                    <span class="textColorRed mr-1">(贈品)</span>
                    <span class="textColorRed" >{{ item.gifts }}</span>
                  </p>
                </router-link>
              </div>
            </div>
          </div>
          <div class="mt-2 md:hidden">
            <p v-if="item.event && !item.matched && !stepNum">
              <span class="textColorRed mr-1">(未符合)</span>
              <span class="textColorRed" >{{item.event }}</span>
            </p>
            <p v-if="item.event && item.matched">
              <span class="textColorRed mr-1">(已符合)</span>
              <span class="textColorRed" >{{ item.event }}</span>
            </p>
            <p v-if="item.gifts" >
              <span class="textColorRed mr-1">(贈品)</span>
              <span class="textColorRed" >{{ item.gifts }}</span>
            </p>
          </div>
        </td>
        <td class="py-2 text-xs textColorBlack text-center td">
          <span>數量</span>
          <div class="w-full flex justify-center" v-if="!stepNum">
            <div class="w-full relative lg:hidden">
              <select class="-mt-2 md:mt-0 mx-auto block appearance-none w-full border border-gray-700 textColorDarkBlack py-2 pl-2 pr-3 rounded leading-tight focus:outline-none bg-white"
                id="grid-state" v-model="item.quantity" @change="updateQuantityToStore(item.quantity, index)" v-if="item.type !== 'SUBSCRIPTION' && (item.id !== 6743 && item.id !==  7739 && item.id !==  8403 && item.id !== 11175 && item.id !== 11174)">
                <option v-for="n in (item.in_stock > limitNum ? limitNum : item.in_stock)" :key="n" :value="n">{{ n }}</option>
              </select>
              <select class="-mt-2 md:mt-0 mx-auto block appearance-none w-full border border-gray-700 textColorDarkBlack py-2 pl-2 pr-3 rounded leading-tight focus:outline-none bg-white"
                id="grid-state" v-model="item.quantity" @change="updateQuantityToStore(item.quantity, index)" v-if="item.type === 'SUBSCRIPTION' && (item.id !== 6743 && item.id !==  7739 && item.id !==  8403 && item.id !== 11175 && item.id !== 11174)">
                <option v-for="n in limitNum" :key="n" :value="n">{{ n }}</option>
              </select>
              <select class="-mt-2 md:mt-0 mx-auto block appearance-none w-full border border-gray-700 textColorDarkBlack py-2 pl-2 pr-3 rounded leading-tight focus:outline-none bg-white"
                id="grid-state" v-model="item.quantity" @change="updateQuantityToStore(item.quantity, index)" v-if="item.type !== 'SUBSCRIPTION' && (item.id === 6743 || item.id ===  7739 || item.id ===  8403 || item.id === 11175 || item.id === 11174)">
                <option v-for="n in 2" :key="n" :value="n">{{ n }}</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 md:px-2 textColorDarkBlack">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
            <div class="UiQty items-center hidden lg:flex justify-between">
              <a class="UiQty_btn minusBtn cursor-pointer px-1" @click="minusNum(item, index)">–</a>
              <input type="text" class="Quantity_input focus:outline-none" v-model="item.quantity" @change="handleInputQuantity(item, index)" @keyup.enter="handleInputQuantity(item, index)">
              <a class="UiQty_btn plusBtn cursor-pointer mx-auto px-1" @click="plusNum(item, index)">＋</a>
            </div>
          </div>
          <p v-if="stepNum === 'step3'" class="m-0">{{ item.quantity }}</p>
        </td>
        <td class="text-center py-2 text-xs textColorBlack td">
          <span>原價</span>
          {{ item.fixed_price }}
        </td>
        <td class="text-center py-2 text-xs textColorBlack td">
          <span>折扣價</span>
          {{ item.pricing }}
        </td>
        <td class="text-center py-2 text-xs textColorBlack td">
          <span>小計</span>
          {{ item.pricing * item.quantity }}
        </td>
        <td class="text-center py-2 text-xs textColorBlack"  v-if="!stepNum">
          <span>下次買</span>
          <a @click="addWish(item, index)" class="cursor-pointer">
            <font-awesome-icon icon="heart" />
          </a>
        </td>
        <td class="text-center py-2 text-xs textColorBlack"  v-if="!stepNum">
          <span>刪除</span>
          <a @click="removeShopItem(item.id, item, index)" class="cursor-pointer">
            <font-awesome-icon icon="times" />
          </a>
        </td>
      </tr>
      <tr class="text-xs border-b" v-for="(item) in gifts" :key="item.id">
        <td class="px-2 sm:px-4 py-4 md:py-6">
          <div class="flex items-start">
            <div class="w-24 md:w-32">
              <a class="itemImg">
                <progressive-img v-if="item.cover"
                  :src="item.cover"
                  :placeholder="item.cover"
                  :blur="30"
                  :customClass="'max-w-full w-32'"
                  :aspect-ratio="1"
                />
                <progressive-img v-else
                  :src="default_url"
                  :placeholder="default_url"
                  :blur="30"
                  :customClass="'max-w-full'"
                  :aspect-ratio="1"
                />
              </a>
            </div>
            <div class="flex flex-col justify-center pl-2">
              <p class="textColorBlack">
                <span>贈品/搭售品</span>
              </p>
              <p class="leading-loose">{{ item.name }}</p>
              <p v-if="item.event">
                <router-link v-if="item.event" :to="{ name: 'sale', params: { category: 'book' }, query: { tag: item.event.id } }" class="cursor-pointer textColorRed underline">{{ item.event.name }}
                </router-link>
                <span class="bgLiveBlack text-white px-1 ml-1" v-if="item.out_of_stock">贈品已贈完<checkOutStock :pName="item.name" /></span>
              </p>
            </div>
          </div>
        </td>
        <td class="py-2 text-xs textColorBlack text-center td">
          <span>數量</span>
          -
        </td>
        <td class="text-center py-2 text-xs textColorBlack td">
          <span>原價</span>
          -
        </td>
        <td class="text-center py-2 text-xs textColorBlack td">
          <span>折扣價</span>
          -
        </td>
        <td class="text-center py-2 text-xs textColorBlack td">
          <span>小計</span>
          -
        </td>
        <td class="text-center py-2 text-xs textColorBlack"  v-if="!stepNum">
          <span>下次買</span>
          -
        </td>
        <td class="text-center py-2 text-xs textColorBlack"  v-if="!stepNum">
          <span>刪除</span>
          -
        </td>
      </tr>
      <tr class="text-xs" v-if="filterEventsAll">
        <td class="px-2 sm:px-4 py-1 w-full" colspan="7">
          <p class="leading-loose w-full" v-for="(item, index) in filterEventsAll" :key="index">
            <router-link :to="{ name: 'sale', params: { category: 'book' }, query: { tag: item.id } }" class="cursor-pointer">
              <span class="bgLiveABCRed text-white px-1 mr-1" v-if="item.matched">已符合</span>
              <span class="bgLiveABCRed text-white px-1 mr-1" v-if="!item.matched">未符合</span>
              <span class="textColorRed">{{ item.name }}</span>
            </router-link>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
import { mapGetters } from 'vuex'
import Cart from '../modules/addCart'
import Regex from '../modules/regex'
import advertising from '@/components/modules/advertising'
import ga4 from '@/components/modules/ga4'
import checkOutStock from '@/components/modules/checkOutStock'
import sweetAlert from '@/components/modules/sweetAlert'
import cloneDeep from 'lodash/cloneDeep'
const POINT_READER_IDS = [6743, 7739, 8403, 11175, 11174]
export default {
  name: 'CartSection',
  components: {
    checkOutStock
  },
  props: {
    products: {
      type: Array,
      required: true
    },
    stepNum: {
      type: String
    },
    events: {
      type: Array,
      default () {
        return []
      }
    },
    gifts: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      limitNum: 100,
      default_url: require('@/assets/images/preset_item.png')
    }
  },
  mixins: [
    Cart,
    Regex,
    advertising,
    ga4,
    sweetAlert
  ],
  computed: {
    ...mapGetters([
      'authorized',
      'user',
      'cartList'
    ]),
    filterEventsAll () {
      return this.events.filter(item => item.type === 'all')
    },

    calcSubscriptionQuantity () {
      let n = 0
      for (let item of this.products) {
        if (item.type === 'SUBSCRIPTION') {
          n += item.quantity
        }
      }

      return n * 2
    }
  },
  methods: {
    async updateQuantityToStore (quantity, index) {
      console.log(this.authorized)
      let products = JSON.parse(JSON.stringify(this.cartList))
      products[index].quantity = quantity
      if (this.authorized) {
        await this.$store.dispatch('postCart', products)
      } else {
        await localStorage.setItem('products', JSON.stringify(products))
        await this.$store.dispatch('updateCart')
      }

      this.$emit('cartListValue')
    },

    // 刪除購物車項目
    async removeShopItem (id, item, index) {
      // 刪除購物車項目
      await this.removeShoppingItem(id, item, index)
      this.$emit('removeShopItem', 'refreshCart')
      // ga4
      this.remove_from_cart(item)
    },

    // 加入收藏
    async addWish (item, index) {
      if (!this.authorized) {
        this.alertPop('success', '尚未登入')
        return
      }

      const productID = item.type === 'SUBSCRIPTION' ? item.link_id : item.id

      try {
        await axios.post(`/products/${productID}/favorite`)
        this.removeShoppingItem(item.id, item, index)

        this.addWishCode({ productID, unit: '1', price: item.pricing })
        this.$emit('removeShopItem', 'refreshCart')

        this.$store.dispatch('isAddingWish', false)
        this.$store.dispatch('isAddingWish', true)
      } catch (err) {
        console.error(err)
      }
    },

    routerChange (item) {
      switch (item.type) {
        case 'BOOK':
          this.$router.push({ path: '/book/detail/' + item.id })
          break
        case 'PACKAGE':
          this.$router.push({ path: '/package/detail/' + item.id })
          break
        case 'MAGAZINE':
          this.$router.push({ path: '/magazine/detail/' + item.id })
          break
        case 'SUBSCRIPTION':
          this.$router.push({ path: '/magazine/detail/' + item.link_id })
          break
        case 'ITEM':
          this.$router.push({ path: '/package/detail/' + item.id })
          break
      }
    },

    async handleInputQuantity (item, index) {
      const isNumber = this.rexNumber(item.quantity)
      const quantity = Number(item.quantity)

      if (!isNumber) return this.updateQuantityToStore(1, index)

      const isSubscription = item.type === 'SUBSCRIPTION'
      const maxLimit = isSubscription ? this.limitNum : item.in_stock

      if (quantity >= maxLimit) {
        this.alertPop('success', '庫存不足')
        return this.updateQuantityToStore(maxLimit, index)
      }

      if (quantity <= 0) {
        return this.removeShopItem(item.id, item, index)
      }

      // 點讀筆限制處理
      if (!isSubscription &&
        POINT_READER_IDS.includes(item.id) &&
        quantity >= this.calcSubscriptionQuantity
      ) {
        this.alertPop('success', '點讀筆限購２個')
        return this.updateQuantityToStore(this.calcSubscriptionQuantity * 2, index)
      }

      this.updateQuantityToStore(quantity, index)
    },

    async minusNum (item, index) {
      const products = cloneDeep(this.cartList)

      if (item.quantity > 1) {
        products[index].quantity--
        if (this.authorized) {
          await this.$store.dispatch('postCart', products)
        } else {
          await localStorage.setItem('products', JSON.stringify(products))
          await this.$store.dispatch('updateCart')
        }
        this.$emit('cartListValue')
      } else {
        // 若數量是 1，再減就是 0，應該直接刪除
        this.removeShopItem(item.id, item, index)
      }
    },

    async plusNum (item, index) {
      const products = cloneDeep(this.cartList)

      const isSubscription = item.type === 'SUBSCRIPTION'
      const maxLimit = isSubscription ? this.limitNum : item.in_stock

      if (item.quantity >= maxLimit) return

      // 點讀筆限購邏輯
      if (!isSubscription &&
        POINT_READER_IDS.includes(item.id) &&
        item.quantity >= this.calcSubscriptionQuantity
      ) {
        this.alertPop('success', '點讀筆限購２個')
        return
      }
      products[index].quantity++
      if (this.authorized) {
        await this.$store.dispatch('postCart', products)
      } else {
        await localStorage.setItem('products', JSON.stringify(products))
        await this.$store.dispatch('updateCart')
      }

      this.$emit('cartListValue')
    }

  }
}
</script>

<style lang="scss" scoped>
.freegiftsTitle {
  opacity: 0;
}
  .UiQty {
    width: 80%;
    border: 1px solid #c7c7c7;
    vertical-align: middle;
    .Quantity_input {
      width: 3em;
      // width: auto;
      border: 0;
      text-align: center;
      letter-spacing: .1em;
      height: 32px;
      vertical-align: middle;
      display: block;
      font-size: 12px;
      line-height: 32px;
      top: 0;
      margin: 0 auto;
      color: #484848;
    }
    .UiQty_btn {
      display: block;
      font-size: 15px;
      z-index: 10;
      width: 36px;
      color: #484848;
      height: 32px;
      line-height: 32px;
      text-align: center;
    }
    .minusBtn {
      &:active {
        padding-top: 1px;
      }
    }
    .plusBtn {
      &:active {
        padding-top: 1px;
      }
    }
  }

  .cart-table td>span {
      display: none;
  }
  @media (max-width: 769px) {
    .cart-table thead tr {
      display: none;
    }
    .cart-table tr {
        display: block;
    }
    .cart-table tr>td:first-child {
        width: 100%;
    }
    .cart-table td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(5), td:nth-child(6), td:nth-child(7) {
        width: 16.45%;
        text-align: center;
    }
    .cart-table td {
        display: inline-block;
        vertical-align: top;
        font-size: 13px;
      }
    .cart-table td>span {
        display: block;
        margin-bottom: 15px;
        color: #000;
    }
    .cart-table td>span {
        display: block;
        margin-bottom: 15px;
        color: #000;
    }
  }

  .checkTable {
    .td {
      width: auto;
    }
  }
  @media (max-width: 769px) {
    .checkTable {
      .td {
        width: 25% !important;
      }
    }
  }

</style>
